module.exports = __webpack_public_path__ + "images/banners/category_estimate/banner_category_bulk_476_a35969eb025a40e3eb7e84d2ccac4b12.png";